export class VendorApiModel {
    vendorID:number;
    vendorName:string;
    vendorAutoID:number;
    UserID:number;
    IsAvailableToPublic:boolean;
}
